import {Theme, mergeStyles} from 'components/FluentUICompat';
import React from 'react';
import {
	CompareResult,
	IParagraphCompareInput,
} from '../../compareDocuments/compareDocuments';
import {useMetadata} from '../_useMetadata';
import {getClassNames, getComparisonColor} from '../CompareVersionPanel.utils';
import {renderParagraph} from 'components/EntityList/ColumnRenderers';
import {useTranslation} from 'react-i18next';
import {RegulatoryDocumentParagraph} from 'types';

const getBorderMarkClassName = (result: CompareResult, theme: Theme) => {
	const color = getComparisonColor(result, theme);

	return mergeStyles({
		borderRight: `5px solid ${color}`,
		height: '100%',
	});
};

export const ParagraphItem: React.FC<{
	comparedParagraph: IParagraphCompareInput | undefined;
	resultType: CompareResult;
	showComparisonMark: boolean;
	showMetadata: boolean;
	theme: Theme;
	disabled?: boolean;
}> = ({
	comparedParagraph,
	resultType,
	showComparisonMark,
	showMetadata,
	theme,
}) => {
	const classNames = getClassNames(theme);
	const {t} = useTranslation();

	const {renderMetadata} = useMetadata();

	return (
		<div
			className={
				showComparisonMark
					? getBorderMarkClassName(resultType, theme)
					: undefined
			}
		>
			<div className={classNames.paragraphItem}>
				{comparedParagraph && (
					<div
						style={{
							width: '90%',
							overflowWrap: 'anywhere',
							whiteSpace: 'normal',
							flex: 1,
						}}
					>
						{renderParagraph(
							{...comparedParagraph, level: 0} as RegulatoryDocumentParagraph,
							t,
						)}
					</div>
				)}
				{comparedParagraph &&
					showMetadata &&
					renderMetadata(comparedParagraph as any)}
			</div>
		</div>
	);
};
